import { render, staticRenderFns } from "./SocietyText.vue?vue&type=template&id=e30402c4&scoped=true&"
import script from "./SocietyText.vue?vue&type=script&lang=js&"
export * from "./SocietyText.vue?vue&type=script&lang=js&"
import style0 from "./SocietyText.vue?vue&type=style&index=0&id=e30402c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30402c4",
  null
  
)

export default component.exports